// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__302kd","signatureBlock":"Footer_signatureBlock__1CDdF","signature":"Footer_signature__2znNp"};